import AuthForm from './AuthFormWrapper';

export default AuthForm;
